import { render, staticRenderFns } from "./VideosManagement.vue?vue&type=template&id=6d792940&scoped=true"
import script from "./VideosManagement.vue?vue&type=script&lang=js"
export * from "./VideosManagement.vue?vue&type=script&lang=js"
import style0 from "./VideosManagement.vue?vue&type=style&index=0&id=6d792940&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d792940",
  null
  
)

export default component.exports